const translations = {
  en: {
    homePage: {
      title: "Medicostores - your trusted digital partner!",
      downloadApp: "Download Desktop App",
      downloadButton: "Download",
      logoImageAlt: "Medicostores",
      networkText: "Connect with verified users who have authentic licenses",
      locationText:
        "Find users in proximity to your location using our geo-location mapping feature.",
      deliveryText:
        " Place orders with multiple Sellers using our marketplace search engine.",
      checklistText: "Check real-time stock and expiry date of each product.",
      inStockText: "Get a Request for products in the market near you.",
      slogan: "It will Take 7 Seconds to Make an Impression , we do it in 5",
      welcomeTo: "Welcome to",
      logIn: "Log In",
      register: "Create your Account",
      otpVerification: "OTP Verification",
      mobileNumber: "Mobile Number",
      loginButtonText: "Login",
      dataPolicyText: "By clicking on login/signing in, you agree to our",
      termsAndConditions: "Terms & Conditions",
      newRegisterText: "New to Medicostores ?",
      registerLinkText: "Register Now",
      loginDescription:
        "Please enter your registered mobile number to receive an OTP code. If you don't receive the code within 60 seconds, you can request a new OTP by resending the request.",
      otpDescription: "Please enter the verification code we sent you at",
      sendOTP: "Verify",
      resendOTPButton: "Resend Code",
    },
    dashboardPage: {
      orderNo: "Order No",
      orderCreatedDate: "Date",
      tradeName: "Trade name",
      distance: "Distance",
      vehicleNumber: "Vehicle Number",
      pickUpStatus: "Pick Up Status",
      notes: "Notes",
      images: "Images",
      market: "Market",
      items: "Items",
      deliveries: "Deliveries",
      distanceType: "Distance Type",
      deliveryBoy: "Delivery Boy",
      dashboardTitle: "Dashboard",
      uploadInventory: "Upload Inventory",
      product: "Product",
      inStock: "In Stock",
      outOfStock: "Out of Stock",
      purchaseOrders: "Purchase Orders",
      orders: "Orders",
      "24Hours": "24 Hours",
      lastWeek: "Last Week",
      todayMostTitle: "Today’s Most Sold Products",
      mostSearchTitle: "Most Searched Products",
      connectedUsers: "Connected Users",
      stockists: "Stockists",
      hospitals: "Hospitals",
      retailers: "Retailers",
      seasonBoys: "Season Boys",
      manufacturers: "Manufacturers",
      seeAll: "See all",
      inventory: "Inventory",
      offers: "Offers",
      running: "Running",
      ended: "Ended",
      onlineOrders: "Online Orders",
      total: "Total",
      status: "Status",
      orderDate: "Order Date",
      refresh: "Refresh",
      preferences: "Preferences",
      minOrder: "Minimum Order",
      whatsappNo: "Whatsapp No",
      qrCode: "QR Code",
      autoApprove: "Auto Approve",
      bankAccountDetailsTitle: "Bank Account Details",
      bankAccount: "Bank Account",
      upi: "UPI Account",
      name: "Name",
      accountNumber: "Account Number",
      ifsc: "IFSC Code",
      vpa: "VPA",
      add: "Add",
      empty: "Empty",
      approveMessage: "Do you approve auto approve for Connected Users?",
      cancelMessage: "Do you want to cancel auto approve for Connected Users?",
      approve: "Approve",
      cancel: "Cancel",
      save: "Save",
      edit: "Edit",
      sendTo: "Please send your inventory to",
      pickupsTitle: "Add Pickups/Deliveries",
      addPickup: "Add Pickup",
      emptyPickupList: "No Pickups/Deliveries",
      submit: "Submit",
      landmark: "Landmark",
      mobile: "Mobile",
      addPickupTitle: "Pickup Details",
      mobileNumber: "Mobile Number",
      date: "Date",
      viewAll: "View All",
      stockist: "Stockist",
      hospital: "Hospital",
      retailer: "Retailer",
      seasonBoy: "Season Boy",
      customerType: "Customer Type",
      invoiceNo: "Invoice No",
      invoiceAmount: "Invoice Amount",
    },
    employee: {
      name: "Name",
      mobileNo: "Mobile No",
      email: "Email",
      delete: "Delete",
      logins: "Logins",
      register: "Register",
      noLogins: "No Logins",
      registerModalTitle: "Register",
      namePlaceholder: "Enter employee name",
      emailPlaceholder: "Enter employee email",
      invalidEmail: "Invalid email",
      required: "Required",
      invalidMobileNo: "Invalid mobile no",
      registerButtonText: "Register",
      resendOTPButton: "Resend OTP",
    },
    errorPage: {
      httpError: "HTTP ERROR",
      internalServerError: "Internal Server Error",
      title: {
        "400": "Bad Request",
        "401": "Unauthorized",
        "403": "Forbidden",
        "404": "Not Found",
        "500": "Internal Server Error",
      },
      description:
        "We are sorry for inconvience. It looks like the server has been deserted for a while. Please be patient or try again later.",
      buttonText: "Go back",
    },
    errors: {
      required: "Required",
      success: "Success",
      error: "Error",
      somethingWentWrong: "Something went wrong",
      E0000: "Error",
      E0001: "Customer Type is required",
      E0002: "First name is required",
      E0003: "Last name is required",
      E0004: "Email is required",
      E0005: "Please enter a valid email",
      E0006: "MobileNumber is required",
      E0007: "Password is required",
      E0008:
        "Password must be at least 8 characters long. It must have at least 1 number and 1 upper case character.",
      E0009: "Password does not match with given password",
      E0010: "Aadhaar Card Number is required",
      E0011: "Please enter a valid aadhaar card number",
      E0012: "Please accept terms & conditions",
      E0013: "Please accept consent",
      E0014: "Pincode is required",
      E0015: "Address Line1 is required",
      E0016: "Location is required",
      E0017: "Landmark is required",
      E0018: "City/Town is required",
      E0019: "District is required",
      E0020: "State is required",
      E0021: "Specify Trade name as mentioned in the GST certificate",
      E0022: "Drug License No1 is required",
      E0023: "Drug License No2 is required",
      E0024: "SB UnitCode is required",
      E0025: "Please enter a valid GSTIN Number",
      E0026: "Please enter a valid Pan Number",
      E0027: "Please enter either GSTIN or PAN number to proceed.",
      E0028:
        "Retailer already registered with medicostores.com. Please sign up using new details.",
      E0029: "Email/mobile number already registered. Please try again.",
      E0030: "Season Boy doesn't exists, please check it again",
      E0031:
        "Season Boy with retailer, can't be created. Please try after sometime...",
      E0032: "Registered user, can't be created. Please try after sometime...",
      E0033: "Uploaded document doesn't match with registered user",
      E0034: "Auth0 gRPC server down, check whether its running",
      E0035:
        "Unable to get geolocation data, check the geolocation server is running",
      E0036: "You have entered an invalid email/mobile or password",
      E0037:
        "Mobile number provided is not registered, please provide registered contact number",
      E0038: "Failed to update password, try after some time.",
      E0039: "Logout token, please login again",
      E0040: "Access Denied",
      E0041: "Something went wrong, Please try after sometime",
      E0042: "Order has not been submitted, please try after sometime.",
      E0043: "Cart already submitted, please check",
      E0044: "Cart not found, please check",
      E0045: "Gstin/Pan number already registered, Please try again",
      E0046: "Invalid current password, please enter valid password again!!",
      E0047:
        "Something went wrong!! Please try, change password again after sometime",
      E0048: "Invalid (Qty + FreeQty), Please correct to nearest number",
      E0049: "Driving License Number is required",
      E0050: "Date Of Birth is required",
      E0051: "Vehicle Number is required",
      E0052: "Type Of Vehicle is required",
      E0053: "Invoice not found, please try after sometime.",
      E0054: "QRCode can't be generated, try after sometime.",
      E0055: "Customer already registered, please check again",
      E0056: "Document/Image Not found",
      E0057: "Please enter a valid Food License",
      E0058: "Food License already registered. Please try again.",
      E0059: "Invalid UPI account, please check again and enter details",
      E0060:
        "Invalid Bank Account Details, please check again and enter valid details",
      E0061: "Outstation deliveries/pickups not available",
    },
    inventoryPage: {
      date: "Date",
      ageInDays: "Age In Days",
      status: "Status",
      noOfProducts: "No. Of Products",
      uploadFile: "Upload File",
      pickFile: "Pick File",
      uploadFileRestriction: "*Excel (XLS, XLSX), PDF, TXT files only",
      upload: "Upload",
      uploading: "Uploading...",
      errorPleasePickFile: "Please pick file to upload",
    },
    medicoInvoicesPage: {
      pageTitle: "Medico Invoices",
      actions: "Actions",
      invoiceNo: "Invoice No",
      invoiceDate: "Invoice Date",
      noOfDeliveries: "No Of Deliveries",
      totalAmount: "Total Amount",
      subscriptionPlan: "Subscription Plan",
      paymentStatus: "Payment Status",
      pay: "Pay",
      openInvoice: "Open Invoice",
      invoiceLink: "Invoice Link",
    },
    navbar: {
      onlinePickups: "Online Pickups",
      offlinePickups: "Offline Pickups",
      onlineOrders: "Online Orders",
      uploadInventory: "Upload Inventory",
      billingDetails: "Billing Details",
      medicoInvoice: "Medico Invoice",
      connectedUsers: "Connected Users",
      upiDetails: "UPI Details",
      receivePayments: "Receive Payments",
      makePayments: "Make Payments",
      payments: "Payments",
      totalOrdersOverview: "Orders Overview",
      b2bCustomers: "B2B Customers",
    },
    referYourCustomers: {
      title: "Refer your customers",
      referralOfferTitle: "5 Deliveries Free",
      referralOfferDescription1:
        "Once activated successfully, you'll qualify for free deliveries.",
      referralOfferDescription2:
        "Add your inventory and get 3 more deliveries for free!",
    },
    titles: {
      upiAccounts: "UPI Accounts",
    },
    labels: {
      attachments: "Attachments",
      authenticationType: "Authentication Type",
      receivedPersonName: "Received Person Name",
      deliveredTime: "Delivered Time",
      deliveredDeliveryBoy: "Delivered Delivery Boy",
      collectedAddress: "Collected Address",
      collectedTime: "Collected Time",
      collectedDeliveryBoy: "Collected Delivery Boy",
      collectedDetails: "Collected Details",
      deliveryDetails: "Delivery Details",
      weight: "Weight",
      noOfParcels: "No. of Parcels",
      paymentType: "Payment Type",
      distanceType: "Distance Type",
      orderDetails: "Order Details",
      totalOrders: "Total Orders",
      onlineOrders: "Online Orders",
      offlineOrders: "Offline Orders",
      pickupOrders: "Pickup Orders",
      emergencyOrders: "Emergency Orders",
      totalOrdersList: "Total Orders List",
      view: "View",
      noOfDeliveries: "No. of Deliveries",
      qrCodeNo: "QR Code No",
      reset: "Reset",
      add: "Add",
      noAccess: "No-Access",
      access: "Access",
      dashboard: "Dashboard",
      mobileNo: "Number",
      code: "Code",
      submit: "Submit",
      error: "Error",
      success: "Success",
      stockists: "Stockists",
      hospitals: "Hospitals",
      retailers: "Retailers",
      employees: "Employees",
      tradeName: "Trade Name",
      address: "Address",
      gstin: "GSTIN",
      distance: "Distance",
      connected: "Connected",
      users: "Users",
      orders: "Orders",
      inventory: "Inventory",
      actions: "Actions",
      status: "Status",
      type: "Type",
      mobileNumber: "Number",
      location: "Location",
      name: "Name",
      dl1: "DL 1",
      dl2: "DL 2",
      cityOrTown: "City/Town",
      addressLine1: "Address Line 1",
      district: "District",
      landmark: "Landmark",
      state: "State",
      pincode: "Pincode",
      customers: "Customers",
      vpa: "VPA",
      qrCode: "QR Code",
      partyName: "Party Name",
      amount: "Amount",
      invoices: "Invoices",
      receivePayments: "Receive Payments",
      makePayment: "Make Payment",
      noResultsFor: "No Results for",
      invAmount: "Inv. Amount",
      qr: "QR",
      date: "Date",
      invoice: "Invoice",
      pay: "Pay",
      payeeName: "Payee Name",
      payeeNumber: "Payee Number",
      password: "Password",
      username: "Username",
      payments: "Payments",
      accounts: "Accounts",
      save: "Save",
      cancel: "Cancel",
      cart: "Cart",
      deleteStockist: "Delete Stockist",
      mfr: "MFR",
      productName: "Product Name",
      qty: "Qty",
      free: "Free",
      ptr: "PTR",
      mrp: "MRP",
      total: "Total",
      totalItems: "Total Items",
      stockist: "Stockist",
      deleteCart: "Delete Cart",
      invoiceDateAge: "Invoice Date/Age",
      sendUpiPayment: "Send UPI Payment",
      share: "Share",
      totalAmount: "Total Amount",
      paidAmount: "Paid Amount",
      invoiceDate: "Invoice Date",
      invoiceImageUrl: "Invoice Image",
      isUPIPaymentCreated: "UPI Payment Created",
      whatsapp: "Whatsapp",
      images: "Images",
    },
    validate: {
      invalidMobileNo: "Invalid mobile number",
      invalidEmail: "Invalid email",
      required: "Required",
    },
    emptyScreen: {
      noConnectedUsers: "No Connected Users Found!",
      noMedicoInvoices: "No Medico Invoices Found!",
    },
    connectedUsersPage: {
      title: "Connected Users",
      searchPlaceholder: "Search in Connected Users",
      hasAccessToInventory: "Has Access To Inventory",
      hasAccessInfo:
        "Access to Inventory, can view all your inventory and can place orders online",
      noAccessInfo:
        "No Access to Inventory, i.e. Can’t see any of your inventory",
    },
  },
};

export { translations };
